import {
  AccordionItem,
  CheckoutAccordion,
} from '../../components/checkout-accordion';
import { useCheckoutContext } from '../../context/checkout.context';
import { testId } from '../../utils';
import { OrderDetails, MobileOrderDetails } from './order-details';
import { PaymentOptions } from './payment';
import { ShippingAddress } from './shipping-address';
import { ShippingOptions } from './shipping-options';
import { useTranslation } from '@rpi/i18n';

export const CheckoutRoute = () => {
  const {
    checkoutState,
    setCheckoutState,
    checkoutCreated,
    isPaymentRequestable,
    braintreeError,
  } = useCheckoutContext();
  const { t } = useTranslation(undefined, { keyPrefix: 'route.checkout' });

  const accordionData: AccordionItem[] = [
    {
      title: t('shipping_address'),
      content: <ShippingAddress />,
      active: true,
      showIcon: checkoutCreated,
      value: 'SHIPPING_ADDRESS',
    },
    {
      title: t('shipping_options'),
      content: <ShippingOptions />,
      active: checkoutCreated,
      showIcon: checkoutCreated,
      value: 'SHIPPING_TIER',
    },
    {
      title: t('payment'),
      content: <PaymentOptions />,
      active: checkoutCreated,
      showIcon: isPaymentRequestable,
      value: 'PAYMENT',
    },
  ];

  return (
    <div className="flex flex-col md:flex-row md:flex-grow md:mx-36 md:gap-8">
      <div className="flex-grow">
        <CheckoutAccordion
          {...testId('checkout-accordion')}
          selectedValue={checkoutState}
          handleSelectedValueChange={setCheckoutState}
          items={accordionData}
        />
      </div>
      <div className="hidden md:flex">
        <OrderDetails
          braintreeError={braintreeError}
          paymentRequestable={isPaymentRequestable}
        />
      </div>
      <div className="flex md:hidden">
        <MobileOrderDetails
          braintreeError={braintreeError}
          paymentRequestable={isPaymentRequestable}
        />
      </div>
    </div>
  );
};
